import { baseAxios } from 'api/axios'
import { apiEndPoints } from 'api/variables'
import { call, put, all, takeLatest } from 'redux-saga/effects'
import {
  actions,
  getTranscodingAudios,
  beginAudioTranscoding,
  stopAudioTranscoding,
  searchAudios,
} from './slice'
import { TranscoderJobStatusType } from 'utils/enum'

function* getAllTranscodingAudios({ payload }: any): any {
  try {
    // yield put(actions.setTranscodingLoading(true))
    const response = yield call(
      baseAxios.post,
      apiEndPoints.audioTranscoding.getAllTranscodingAudios(
        payload?.skip,
        payload?.limit,
      ),
    )
    yield put(actions.setAudioTranscodingLoading(false))
    yield put(
      actions.setTranscodingAudios({ data: response, skip: payload?.skip }),
    )
  } catch (err) {
    console.log(err)
  } finally {
    yield put(actions.setAudioTranscodingLoading(false))
  }
}

function* startAudioTranscoding({ payload }: any): any {
  try {
    yield put(
      actions.setStartAudioTranscodingRowLoader({
        loading: true,
        transcodingId: payload?.audioId,
      }),
    )
    yield call(
      baseAxios.post,
      apiEndPoints.audioTranscoding.startTranscoding,
      payload,
    )
    yield put(
      actions.setStartAudioTranscodingRowLoader({
        loading: false,
        transcodingStatus: TranscoderJobStatusType.InProgress,
        transcodingId: payload?.audioId,
      }),
    )
    yield getAllTranscodingAudios({})
  } catch (err) {
    console.log(err)
  } finally {
    yield put(actions.setAudioTranscodingStartLoading(false))
  }
}

function* cancelAudioTranscoding({ payload }: any): any {
  try {
    yield put(actions.setAudioTranscodingLoading(true))

    yield call(
      baseAxios.post,
      apiEndPoints.transcoding.cancelTranscoding,
      payload,
    )
    yield getAllTranscodingAudios({})
    yield put(actions.setAudioTranscodingLoading(false))
  } catch (err) {
    console.log(err)
  } finally {
    yield put(actions.setAudioTranscodingLoading(false))
  }
}

function* searchAllAudios({ payload }: any): any {
  try {
    yield put(actions.setAudioTranscodingLoading(true))

    const response = yield call(
      baseAxios.get,
      apiEndPoints.audioTranscoding.searchAudios(payload?.searchValue),
    )
    yield put(actions.setTranscodingAudioSearch(response))
    yield put(actions.setAudioTranscodingLoading(false))
  } catch (err) {
    console.log(err)
  }
}

export function* audioTranscodingSaga(): any {
  yield all([yield takeLatest(getTranscodingAudios, getAllTranscodingAudios)])
  yield all([yield takeLatest(beginAudioTranscoding, startAudioTranscoding)])
  yield all([yield takeLatest(stopAudioTranscoding, cancelAudioTranscoding)])
  yield all([yield takeLatest(searchAudios, searchAllAudios)])
}
